import { serialize } from 'object-to-formdata'

export const objectToFormData = (object) => {
  return serialize(object, {
    /**
     * include array indices in FormData keys
     * defaults to false
     */
    indices: true,

    /**
     * treat null values like undefined values and ignore them
     * defaults to false
     */
    nullsAsUndefineds: false,

    /**
     * convert true or false to 1 or 0 respectively
     * defaults to false
     */
    booleansAsIntegers: true,

    /**
     * store arrays even if they're empty
     * defaults to false
     */
    allowEmptyArrays: false
  })
}